export default __webpack_public_path__ + "static/media/ticket-blue.b8ff0328.svg";